import io from 'socket.io-client'
import { getAccessToken, getLiveStatus } from "@/api";


export default class ChatServices {

  constructor (options) {
    // 클래스 변수 생성
    this._Socket = {}
    this._BlackListTypeCode = {
      0: {value: 0, text: '벙어리'},
      1: {value: 1, text: '강제퇴장'},
      2: {value: 2, text: '영구퇴장'}
    }
    this._ChatServer = {
      live: window.ENV.CHAT.LIVE,
      vod: window.ENV.CHAT.VOD
    }

    this._Options = {
      chatServer: this._ChatServer['live'],
      chatMode: 'live',
      reconnectDelay: 10000,
      timeout: 20000,
      accessToken: 'SLL-NONE-USER'
    }
    
    this._JoinRoomInfo = {
      room: options.room,
      user: {
        // nickName: options.user.nickName || '',
        permission: options.accessToken ? 1 : 4
      }
    }

    this._Heartbeat = null
    this._TargetPlayer = options.playerBox

    
    // 채팅서버 환경 설정
    if (options.mode) {
      if (Object.keys(this._ChatServer).indexOf(options.mode) < 0) {
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
          return alert('채팅서버 환경설정이 잘못되었습니다.')
        }, 500)
      }

      this._Options.chatServer = this._ChatServer[options.mode]
      this._Options.chatMode = options.mode

      // 테스트용 코드
      // this._Options.chatServer = this._ChatServer['live']
      // this._Options.chatMode = 'live'
    }


    // 초기 생성자 옵션 적용
    if (options) {
      if (options.reconnectDelay) this._Options.reconnectDelay = options.reconnectDelay
      if (options.timeout) this._Options.timeout = options.timeout
      if (options.accessToken) this._Options.accessToken = options.accessToken
      if (options.mode) {
        if (options.mode === 'vod') this._Options.accessToken = 'SLL-VOD'
      }
      console.log(this._Options)
    }


    // 소켓 커넥트
    const url = this._Options.chatServer
    const socketOption = {
      transports: ['websocket'],
      reconnectionDelayMax: this._Options.reconnectDelay,
      timeout: this._Options.timeout,
      query: {
        authorization: this._Options.accessToken
      },
      secure: true
    }

    
    this._Socket = io(url, socketOption)

    // this._Socket.on('event', function(data){
    //   console.log(data)
    // });


    this._Socket.on('connect', () => {
      console.log('Connected - Chatting Server!!')
      this._JoinRoom()
    })
  }

  // 채팅방 정보 업데이트
  _UpdateRoomInfo (obj) {
    this._JoinRoomInfo.room.room = obj.room
  }


  // 채팅 방 입장
  _JoinRoom () {
    console.log('joinRoom!', this._JoinRoomInfo)
    
    this._Socket.emit('joinRoom', this._JoinRoomInfo)
    this._Socket.on('joinRoom', function (data) {
      console.log(data)
      if (data.res.resCode) {
        const joined = this._JoinResult(data.res.resCode)
        if (joined) { this._heartbeatFunc() }
      }  
    }.bind(this))

    if (this._Options.chatMode === 'vod' && !this._Heartbeat) this._heartbeatFunc()
  }


  // 채팅창 종료
  _LeaveRoom () {
    if (this._Socket.connected) {
      this._clearChatService()
      console.log('disconnect')

      return true
    }
  }

  _heartbeatFunc () {
    const socket = this._Socket
    const target = document.querySelector(this._TargetPlayer)
    this._Heartbeat = setTimeout(() => {
      if (!target) {
        this._clearChatService()
        return false
      }

      socket.emit('heartbeat')
      
      this._heartbeatFunc()
    }, 10000)
  }

  _clearChatService () {
    const data = {
      room: this._JoinRoomInfo.room.room
    }
    this._Socket.emit('leaveRoom', data)
    this._Socket.emit('disconnect')
    this._Socket.disconnect()

    if (this._Heartbeat) {
      clearTimeout(this._Heartbeat)
      this._Heartbeat = null
    }
  }


  // 채팅 resultCode
  _JoinResult (resCode) {
    const code = {
      '0001' : function () {
        return true
      },
      '0004' : function () {
        console.log('empty')
      },
      '1001': function () {
        alert('회원정보 조회에 실패했습니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '1002': function () {
        alert('다른 기기에서 로그인되어 연결 종료합니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '1003': function () {
        alert('차단 당한 방송 입니다. 입장이 불가능 합니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '1004': function () {
        alert('입력하신 내용이 규정에 위반되어 강제 퇴장되었습니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '1005': function () {
        alert('채팅 에티켓 미준수로 관리자에 의해 채팅이 금지된 상태입니다.')
        return false
      }.bind(this),
      '1403': function () {
        return this._refreshToken()
      }.bind(this),
      '2001': function () {
        alert('유효하지 않은 채팅방 입니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '2002': function () {
        alert('유효하지 않은 메세지 입니다.')
        return false
      }.bind(this),
      '3001': function () {
        alert('정상적인 방송이 아닙니다.')
        return false
      }.bind(this),
      '9000': function () {
        alert('유효하지 않은 소켓통신 입니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this),
      '9001': function () {
        alert('유효하지 않은 권한 입니다.')
        setTimeout(() => {
          window.closePip()
          this._LeaveRoom()
        }, 500)
        return false
      }.bind(this)
    }
    code[resCode]()
  }

  _SendChat (chatMsg) {
    if (chatMsg.msg.trim() === '') return false

    let data = {
      room: this._JoinRoomInfo.room,
      message: {
        msgType: 0,
        msg: chatMsg.msg
      }
    }
    this._Socket.emit('chatMessage', data)
  }


  // 토큰 갱신 함수
  async _refreshToken () {
    if (this._busy) return false
    this._busy = true
    let res = await getAccessToken(sessionStorage.getItem('refreshToken'))
    console.log(res)
    if (res.data.jsonData.resultCode === '0001') {
      sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)
      sessionStorage.setItem('nickName', res.data.jsonData.nickName)
      sessionStorage.setItem('userSysId', res.data.jsonData.userSysId)

      this._LeaveRoom()

      this._JoinRoom()

      this._busy = false

      return true
    } else {
      alert('토큰 갱신에 실패했습니다. 새로고침 해 주세요.')
      return false
    }
  }

  // 좋아요
  async _like () {
    let data = {
      room: this._JoinRoomInfo.room
    }
    this._Socket.emit('like', data)
  }


  // 다시보기 채팅 요청 함수
  async _ChatHistory (st, ed, boolean) {
    if (this._Options.chatMode !== 'vod') return false

    let obj = {
      room: this._JoinRoomInfo.room,
      vod: {
        startDate: st,
        endDate: ed
      }
    }
    if (boolean) {
      obj.vod.beforeCnt = 20
    }
    console.log(obj)
    this._Socket.emit('vodChatHist', obj)
  }

  // VOD 전용 특정 시점 채팅방 고정값 수신
  async _VodFixInfo (time) {
    if (this._Options.chatMode !== 'vod') return false

    let obj = {
      room: this._JoinRoomInfo.room,
      vod: {
        startDate: time
      }
    }
    console.log(obj)
    this._Socket.emit('fixInfo', obj)
  }

  async _ChkLiveStatus (broadcastSysId) {
    let res = await getLiveStatus(broadcastSysId)
    console.log(res)

    if (res.data.jsonData.resultCode === '0001' && res.data.jsonData.liveFlag === 1) {
      return false
    }
    return true
  }

  // 가위바위보게임 - 게임 참여
  _JoinGame (gameSysId) {
    let data = {
      game: {
        gameSysId: gameSysId
      }
    }
    this._Socket.emit('joinGame', data)
  }

  // 가위바위보게임 - 가위바위보내기(참가자)
  _ChooseGameUser (obj) {
    let data = {
      game: obj
    }
    this._Socket.emit('chooseGameUser', data)
  }


}